module.exports = __webpack_public_path__ + "img/photos/video@2x.jpg";